import Header from './Header.jsx';
import BaseModal from '../widgets/BaseModal.jsx';
import {twMerge} from 'tailwind-merge';
import {Button} from "@heroui/react";

export default function EmptyProjects({icon, title, children, className, isShowIcon = true, isShowAction = false, actionChildren = null, actionTitle = '', actionIcon = 'eva eva-arrow-forward', actionClassName = '', ...props}) {
	return (
		<div
			className={twMerge([
				"relative flex justify-center items-center py-36 1bg-[url('./assets/images/image-bg1.png')] bg-center bg-cover",
				className
			])}>
			<div className="max-w-3xl mx-auto text-center px-6">
				{isShowIcon ? icon || <img src="/images/404-icon.png" alt="upload-icon" className="max-w-32 mx-auto mb-5 grayscale"/> : ''}
				<h1 className="text-3xl mb-5 font-bold font-sans">{title || 'Oops…'}</h1>
				{children || <>
					<p className="mb-5 text-slate-500">
						here are no results that match your search. <br/> Try a different search term or remove some filters.
						Start dubbing your videos and audio today, and unlock endless possibilities tomorrow! Break
						language barriers, reach global audiences, and take your content to every corner of the world.
						The future of communication starts here!
					</p>
				</>}
				
				<div className="mt-5">
					{actionChildren}
					{typeof props?.onAction === 'function' && isShowAction &&
						<Button
							onPress={() => {
								if (props?.onAction && typeof props?.onAction === 'function') {
									props.onAction();
								} else {
									console.log('Action not defined');
								}
							}}
							variant="flat" className={twMerge([
							"bg-black text-white px-10 py-6 font-sans",
							actionClassName
						])}>
							<i className={`${actionIcon} text-xl`}></i>
							{actionTitle || 'Get Started'}
						</Button>
					}
				</div>
			</div>
		</div>
	);
}
